import React from 'react'

import Confetti from 'react-confetti'

const CongraEffect = () => {
  
  return (
    <Confetti
    
    />
  )
}


export default CongraEffect